import * as types from "./types";
export const TOKEN = "ftoken";
export const UINFO = "fexp";

export function updateToken(
  token: string,
  expiresAt: number
): types.FacebookAction {
  localStorage.setItem(TOKEN, token);
  localStorage.setItem(UINFO, expiresAt + "");
  return {
    type: types.CHANGE_FACEBOOK_TOKEN,
    token: token,
    expiresAt: expiresAt
  };
}

export function getFToken(): string {
  return localStorage.getItem(TOKEN);
}
export function getFExp(): number {
  return parseInt(localStorage.getItem(UINFO));
}



// WEBPACK FOOTER //
// ./src/store/facebook/actions.ts